"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATUS_MODIFIED = exports.STATUS_VALID = exports.STATUS_CAUTION = exports.STATUS_INVALID = void 0;
exports.STATUS_INVALID = 'invalid';
exports.STATUS_CAUTION = 'caution';
exports.STATUS_VALID = 'valid';
exports.STATUS_MODIFIED = 'modified';
//# sourceMappingURL=status.js.map